<template>
  <base-tooltip v-bind="$props" :visible="visible && !disabled" v-element-hover="onHover">
    <template #tooltip-label>
      <slot />
    </template>
    <slot name="tooltip-trigger">
      <inline-svg class="info-icon" :src="require('@ui-kit/assets/images/general/info.svg')" />
    </slot>
  </base-tooltip>
</template>

<script>
import BaseTooltip from '@ui-kit/components/tooltips/BaseTooltip.vue';
import { vElementHover as elementHover } from '@vueuse/components';

export default {
  components: { BaseTooltip },
  directives: { elementHover },
  name: 'tooltip',
  props: {
    side: {
      type: String,
      default: 'bottom',
      validator(value) {
        return ['top', 'bottom'].indexOf(value) !== -1;
      },
    },
    position: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right', 'center'].indexOf(value) !== -1;
      },
    },
    dark: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    onHover(visible) {
      this.visible = visible;
    },
  },
};
</script>
